import { Table } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionChainAction } from '../../../../actions/optionChainAction';
import PBTableCells from './putBoardTableCells';
import PutBoardTableHeadingRow from './PutBoardTableHeadingRow';

const PutBoardTable = ({
  styles,
  isMobile,
  topPosition,
  rows,
  toggleModal,
  setState,
  state,
  setWatchListData,
}) => {
  const chainState = useSelector((state) => state.optionChainReducer);
  const { zoom, favioute, checkPut, hideShading } = chainState;

  const dispatch = useDispatch();

  const setOptionChainState = (payload) =>
    dispatch(setOptionChainAction(payload));

  const setCheckedValue = (index, data) => {
    let newCh = JSON.parse(JSON.stringify(checkPut));
    newCh[index].value = !checkPut[index].value;
    setOptionChainState({ checkPut: newCh });
    setWatchListData(data, index);
  };

  return (
    <Table>
      <PutBoardTableHeadingRow
        styles={styles}
        isMobile={isMobile}
        topPosition={topPosition}
        zoom={zoom}
        favioute={favioute}
        checkPut={checkPut}
      />

      {state.show && (
        <PBTableCells
          styles={styles}
          isMobile={isMobile}
          favioute={favioute}
          checkPut={checkPut}
          rows={rows}
          hideShading={hideShading}
          toggleModal={(data) => toggleModal(data)}
          setState={(data) => setState(data)}
          setCheckedValue={setCheckedValue}
        />
      )}
    </Table>
  );
};
export default PutBoardTable;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicPutBoard/basiCPutBoardWeb/putBoardTable.jsx